/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Coverage_HintInputs */

const en_landing_preview_coverage_hint = /** @type {(inputs: Landing_Preview_Coverage_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,240 of 1,400 notes indexed`)
};

/**
* | output |
* | --- |
* | "1,240 of 1,400 notes indexed" |
*
* @param {Landing_Preview_Coverage_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_coverage_hint = /** @type {((inputs?: Landing_Preview_Coverage_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Coverage_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_coverage_hint(inputs)
});